import { render, staticRenderFns } from "./BottomToolbar.vue?vue&type=template&id=7384d3dc&scoped=true&"
import script from "./BottomToolbar.vue?vue&type=script&lang=js&"
export * from "./BottomToolbar.vue?vue&type=script&lang=js&"
import style0 from "./BottomToolbar.vue?vue&type=style&index=0&id=7384d3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7384d3dc",
  null
  
)

export default component.exports